import { Link } from "react-router-dom";
import { ArrowRight, DraftingCompass, Scale, Building2, HardHat, Users } from "lucide-react";
import { SEO, breadcrumbSchema } from "../components/SEO";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { Reveal } from "../components/Reveal";
import { PagePhoto } from "../components/PagePhoto";
import { pagePhotos } from "../content/photos";
import { CTASection } from "../components/CTASection";
import { trackEvent } from "../lib/analytics";
import { useLp } from "../i18n/lang";
import { useCopy } from "../i18n/copy";

const audienceIcons = [DraftingCompass, Scale, Building2, HardHat, Users];

export default function Professionals() {
  const c = useCopy("professionals");
  const cr = useCopy("crumbs");
  const cm = useCopy("common");
  const lp = useLp();
  const crumbs = [
    { name: cr.home, path: lp("/") },
    { name: cr.professionals, path: lp("/profesionales/") },
  ];
  return (
    <>
      <SEO
        title={c.seoT}
        description={c.seoD}
        path="/profesionales/"
        jsonLd={[breadcrumbSchema(crumbs)]}
      />
      <Breadcrumbs items={crumbs} />
      <section className="container-site section-gap !pt-10" data-testid="professionals-page">
        <Reveal>
          <p className="tech-label mb-4">{c.kicker}</p>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight max-w-3xl">
            {c.h1}
          </h1>
          <p className="mt-5 max-w-2xl text-base sm:text-lg text-slate-600 leading-relaxed">
            {c.intro}
          </p>
        </Reveal>
        <PagePhoto photo={pagePhotos["_profesionales"]} className="mt-12 max-w-4xl" />
        <div className="mt-14 grid md:grid-cols-2 gap-px bg-slate-200 border hairline max-w-5xl">
          {c.audiences.map((a, i) => {
            const Icon = audienceIcons[i];
            return (
              <Reveal key={a.title} delay={i * 0.05} className="bg-paper">
                <div className="p-8 sm:p-10 h-full">
                  <Icon size={24} className="text-terracotta" aria-hidden="true" />
                  <h2 className="mt-5 text-lg sm:text-xl font-semibold text-ink">{a.title}</h2>
                  <p className="mt-3 text-[15px] text-slate-600 leading-relaxed">{a.text}</p>
                </div>
              </Reveal>
            );
          })}
          <Reveal delay={0.25} className="bg-obsidian">
            <div className="p-8 sm:p-10 h-full flex flex-col justify-center">
              <h2 className="text-lg sm:text-xl font-semibold text-paper">{c.collabH}</h2>
              <p className="mt-3 text-[15px] text-slate-300 leading-relaxed">
                {c.collabText}
              </p>
              <Link
                to={lp(`/contacto/?necesidad=${encodeURIComponent(cm.unclearNeed)}`)}
                data-testid="professionals-cta"
                onClick={() => trackEvent("cta_budget_click", { location: "profesionales" })}
                className="btn-primary mt-7 w-fit"
              >
                {c.collabCta} <ArrowRight size={16} aria-hidden="true" />
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
      <CTASection title={c.ctaT} text={c.ctaX} />
    </>
  );
}
